export const offerStatus = {
  DRAFT: 'DRAFT',
  RUNNING: 'RUNNING',
  PAUSE: 'PAUSE',
  CLOSED: 'CLOSED',
} as const;

export type OfferStatus = (typeof offerStatus)[keyof typeof offerStatus];
